import React from "react";

type SummaryItemProps = {
  items: string[];
  children: string;
  onEdit: () => void;
};

const SummaryItem = ({ items, children, onEdit }: SummaryItemProps) => {
  return (
    <div className="flex justify-between items-center my-2">
      <div>
        <div className="text-base mb-3">{children}</div>
        {items.map((item) => (
          <div className="text-sm">{item}</div>
        ))}
      </div>
      <div className="p-3 font-semibold" onClick={onEdit}>
        Edit
      </div>
    </div>
  );
};

export default SummaryItem;
